// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaser":"teaser_jp_d2xTeaser__IERu4"};